import { CustomColumnProps } from '@ihsm/ui-shared';
import { TimeseriesChartItem } from 'shared/components/TimeseriesChart/types';

export const getColumns = (
  chartData: TimeseriesChartItem[]
): CustomColumnProps[] => {
  const customColumns = [];
  const dateColumn = {
    columnType: 'date',
    name: 'date',
    title: 'Date',
  };

  customColumns.push(dateColumn);
  chartData.forEach(({ name }) => {
    customColumns.push({
      columnType: 'currency',
      name,
      title: name.charAt(0).toUpperCase() + name.slice(1),
    });
  });

  return customColumns as CustomColumnProps[];
};
